import { render, staticRenderFns } from "./Ameneties.vue?vue&type=template&id=8586d2ac&scoped=true&"
import script from "./Ameneties.vue?vue&type=script&lang=js&"
export * from "./Ameneties.vue?vue&type=script&lang=js&"
import style0 from "./Ameneties.vue?vue&type=style&index=0&id=8586d2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8586d2ac",
  null
  
)

export default component.exports